export enum WebfeederSubscribeTypeEnum {
  UNSUBSCRIBE = '0',
  SUBSCRIBE = '1'
}

export enum WebfeederModuleEnum {
  QUOTE = 'quotes',
  NEGOTIATION = 'negotiation',
  CHART = 'chart'
}

export enum WebfeederServiceEnum {
  AGGREGATED_BOOK = 'aggregatedBook',
  MINI_BOOK = 'miniBook',
  QUOTE_TRADE = 'quoteTrade',
  CANDLE_CHART = 'candleChart',
  DAILY_ORDER = 'dailyOrder',
  FINANCIAL_ACCOUNT_INFORMATION_COMPL = 'financialAccountInformationCompl',
  FINANCIAL_ACCOUNT_INFORMATION = 'financialAccountInformation',
  LOGIN_DUPLICATED = 'loginDuplicated',
  POSITION = 'position',
  QUOTE = 'quote',
  STATUS_DIFUSION = 'statusDifusion',
  STATUS_OMS = 'statusOMS',
  RESUME_HIGH_LIST = 'highList',
  RESUME_FALL_LIST = 'fallList',
  RESUME_HIGH_VOLUME_LIST = 'highVolumeList',
  RESUME_FALL_VOLUME_LIST = 'fallVolumeList',
}

export enum WebfeederMessageTypeEnum {
  AGGREGATED_BOOK_TYPE = 'AggregatedBookType',
  MINI_BOOK_TYPE = 'MiniBookType',
  BUSINESS_BOOK_TYPE = 'BusinessBookType',
  CHART_SVC_BY_FN = 'ChartSvcByFn',
  DAILY_ORDER = 'dailyOrder',
  FINANCIAL_COMPL_SVC_BY_FN = 'FinancialComplSvcByFn',
  FINANCIAL_SVC_BY_FN = 'FinancialSvcByFn',
  POSITION = 'position',
  QUOTE_TYPE = 'QuoteType',
  RESUME_INDEX_TYPE = 'ResumeIndexType',
  STATUS_DIFUSION_SVC_BY_FN = 'StatusDifusionSvcByFn',
  STATUS_OMS_SVC_BY_FN = 'StatusOMSSvcByFn'
}
